module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-26b8a2cfe01e3e333a3531f0a9ebaddc.png";